import {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
  WalletDatePreset,
  WALLET_DATE_PRESET_OPTIONS,
} from '../wallet/walletDateRange'

export type UserDatePreset = WalletDatePreset

export type UserFilterState = {
  preset: UserDatePreset
  date_from: string
  date_to: string
  label: string
  all_time?: boolean
  profession: string
  role: number | null
}

export const USER_DATE_PRESET_OPTIONS = WALLET_DATE_PRESET_OPTIONS

export const USER_ROLE_OPTIONS: {value: string; label: string; roleId: number | null}[] = [
  {value: '', label: 'All roles', roleId: null},
  {value: 'driver', label: 'Driver', roleId: 2},
  {value: 'passenger', label: 'Passenger', roleId: 3},
  {value: 'both', label: 'Both', roleId: 4},
]

export const getDefaultUserFilter = (): UserFilterState => {
  const range = getRangeForPreset('allTime')
  return {
    ...range,
    profession: '',
    role: null,
  }
}

export const buildUserFilterSummary = (
  filter: UserFilterState,
  search: string,
  totalRecords?: number
): string => {
  const rangeText = filter.all_time
    ? 'all dates'
    : filter.date_from === filter.date_to
      ? formatDisplayDate(filter.date_from)
      : `${formatDisplayDate(filter.date_from)} – ${formatDisplayDate(filter.date_to)}`

  const roleLabel =
    USER_ROLE_OPTIONS.find((o) => o.roleId === filter.role)?.label ?? 'all roles'
  const professionText = filter.profession ? filter.profession : 'all professions'

  const parts = [filter.label, `(${rangeText})`, roleLabel, professionText]
  if (search.trim()) parts.push(`search: "${search.trim()}"`)
  if (totalRecords !== undefined) {
    parts.push(`${totalRecords} user${totalRecords === 1 ? '' : 's'}`)
  }
  return parts.join(' · ')
}
